export default "__VITE_ASSET__CTy_6wXN__"